// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3RwMA","buttons":"Footer_buttons__kWGSU"};